import React, { useEffect } from 'react'
import { CloseOutlined} from '@ant-design/icons';

import "./SideBarComponent.css"

interface Props{
    open: boolean
    setOpen:React.Dispatch<React.SetStateAction<boolean>>
    children?: React.ReactNode
}

const SideBarComponent = ({open, setOpen, children}:Props) => {

  useEffect(() => {
    if (open) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    // Función de limpieza para remover la clase si el componente se desmonta
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [open]); // El efecto se ejecuta cada vez que isSidebarOpen cambia

  
  return (
    <>
    <div className='SideBardComponent-Component' style={{right:open ? "40vw" : "110vw"}}>
        <div className='SideBar-Header'>


            <div className='Sidebar-Header-logo'>
                <img src='/logo.png'  />
            </div>

            <div className='SideBar-Header-close'>
                <CloseOutlined onClick={()=>{setOpen(false)}} style={{cursor:"pointer", color:"#FFF"}} />
            </div>

        </div>
        <div className='SideBar-content'>
        {children}
        </div>
    </div>
    
    <div className='SideBarComponent-Background' onClick={()=>{setOpen(false)}} style={{display:open ? "flex" : "none"}}>

    </div>
    </>

  )
}

export default SideBarComponent